// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__O-bjZ","footer":"layout_footer__uruvt"};